import { Button, Col, Divider, Row } from "antd"
import { allBanks, ROUTES_PATH } from "../../utils/constants"
import { BankSelector, ButtonGroup } from "../../components"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { saveProvidersList, selectBank } from "../../redux/providerSlice"
import { EntityType } from "../../models/EntityType"
import { ProviderType } from "../../models/ProviderType"
import { BankreaderService } from "../../services/Bankreader"
import { IRootState } from "../../redux/store"
import { isLoading } from "../../redux/loaderSlice"
import { showModal } from "../../redux/modalSlice"
import { selectFlowStep } from "../../redux/headerSlice"
import { ErrorType } from "../../models/ErrorType"
import { sendError } from "../../redux/errorSlice"
import { StorageService } from "../../services/Storage"
import { WebsocketCode } from "../../models/Websocket"
import { EventMessageService } from "../../services/EventMessage"
import { defaultBankMode, saveRequest } from "../../redux/requestSlice"
import InsightService from "../../services/Insight"

export const Entities: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const bankSelected = useSelector((state: IRootState) => state.provider.value.bank_selected);
  const providersList = useSelector((state: IRootState) => state.provider.value.providers);
  const thirdParty = useSelector((state: IRootState) => state.request.value.data.third_party);
  const bankreaderId = useSelector((state: IRootState) => state.request.value.data.bankreader_id);
  const pepperOne = useSelector((state: IRootState) => state.params.value.pepperOne);
  const senior = useSelector((state: IRootState) => state.params.value.senior);
  const [bankCards, setBankCards] = useState<EntityType[] | null>(null);
  const [selectorOpen, setSelectorOpen] = useState<boolean>(false);

  const selectTopBank = (event: EntityType) => {
    const providerSelected = providersList.find((bank: any) => bank.display_name === event.name);
    if (providerSelected) {
      dispatch(selectBank(providerSelected));
      nextPage(providerSelected);
    } else {
      dispatch(sendError(ErrorType.BANK_FAILED));
      navigate(ROUTES_PATH.UNKNOWN_ERROR);
    }
  }

  const handleSelectedBank = async (event: any) => {
    dispatch(selectBank(event));
  }

  const prevPage = () => {
    if (selectorOpen) {
      setSelectorOpen(false);
    } else {
      dispatch(showModal(true));
    }
  }

  const nextPage = async (bank?: ProviderType) => {
    InsightService.logTrace('BankSelected', [
      { thirdParty: bank?.third_party || bankSelected?.third_party },
      { name: bank?.display_name || bankSelected?.display_name},
      { inputProvider: bank?.name || bankSelected?.name },
      { connectionType: bank?.connection_type || bankSelected?.connection_type},
    ]);
    dispatch(isLoading(true));
    BankreaderService.sendWebsocketCode(bankreaderId, { code: WebsocketCode.BANK_SELECTED });
    navigate(ROUTES_PATH.LOGIN);
  }

  const displayAllProviders = (providers: any) => {
    let entities: any[] = [];
    providers.forEach((provider: ProviderType) => {
      const data = allBanks.find((bank: EntityType) => bank.name === provider.display_name);
      if (data) {
        const obj = Object.assign(data, {
          priority: provider.priority
        });
        entities.push(obj);
      } else {
        const obj = {
          name: provider.display_name,
          logo: 'DefaultBank.svg',
          priority: provider.priority
        }
        entities.push(obj);
      }
    })
    entities.sort((a: any, b: any) => {
      return a.priority - b.priority
    })
    setBankCards(entities);
    dispatch(isLoading(false));
  }

  const getProviders = async () => {
    BankreaderService.getProviders(thirdParty)
      .then((data: any) => {
        const list = data.providers;
        let newList: ProviderType[] = [];
        list.map((provider: any) => {
          const providerLogo = allBanks.find((bank: any) => bank.name === provider.display_name);
          let logoSelected;
          if (providerLogo?.logo) {
            logoSelected = providerLogo.logo;
          } else {
            logoSelected = 'DefaultBank.svg';
          }
          const data = Object.assign(provider, {
            logo: logoSelected
          });
          newList.push(data);
        });
        dispatch(saveProvidersList(newList));
        const providersShown = senior ? newList : newList.filter((bank: any) => {
          return bank.priority <= 6;
        });
        displayAllProviders(providersShown);
      })
      .catch(() => {
        dispatch(sendError(ErrorType.PLATFORM_FAILED));
        navigate(ROUTES_PATH.UNKNOWN_ERROR);
      });
  }

  useEffect(() => {
    dispatch(isLoading(true));
    dispatch(defaultBankMode(false));
    pepperOne && EventMessageService.sendMessageEvent('hide-return-button')
    const bankreaderStored = StorageService.getBankreaderStore();
    if(!bankreaderId && bankreaderStored) {
      dispatch(saveRequest(bankreaderStored));
    }
    dispatch(selectFlowStep(1));
    getProviders();
  }, []);


  return (
    <div className='pepper-page pepper-page-padding'>
      <div className="pepper-title">Selecciona el banco donde recibes tus ingresos</div>
      <div className="entities-panel">
        {!selectorOpen && <div className={`${senior && 'all-entities'}`}>
          <Row justify="center" gutter={[12, 12]}>
            {bankCards && bankCards.map((bank: any) => (
              <Col key={bank.name} span={12} className="gutter-row" onClick={() => selectTopBank(bank)}>
                <div className={`bank-card ${senior && 'bank-card-senior'}`}>
                  <Button className="top-bank-name">
                    <img src={`/bankLogos/${bank.logo}` || '/bankLogos/bank-not-found.svg'} className={`${(bank.logo === 'CajaRuralDefault.svg' || bank.logo === 'DefaultBank.svg') && 'rural-bank-card'}`} />
                    {(bank.logo === 'CajaRuralDefault.svg' || bank.logo === 'DefaultBank.svg') && <div className='bank-card-subtitle'>{bank.name}</div>}
                  </Button>
                </div>
              </Col>
            ))}
          </Row>
          <Divider />
        </div>}
        {!senior && <>
          <p>¿No encuentras tu banco? Escribe el nombre de tu banco en el buscador y pulsa continuar:</p>
          <BankSelector active={(event: boolean) => setSelectorOpen(event)} selection={handleSelectedBank} />
        </>}
      </div>
      <ButtonGroup continueDisabled={!bankSelected?.name} handleOk={nextPage} handleCancel={prevPage} hideCancelBtn={!selectorOpen} />
    </div>
  )
}
